import React from 'react';
import { ARTICLE_TYPE } from '@atlaskit/help';
import type { articleId, HistoryItem } from '@atlaskit/help';

export const DEFAULT_NAVIGATION_DATA = {
  articleId: { id: '', type: ARTICLE_TYPE.HELP_ARTICLE },
  history: [],
};

export const useHelpNavigationHelper = () => {
  const [navigationDataState, setNavigationDataState] = React.useState<{
    articleId: articleId;
    history: HistoryItem[];
  }>(DEFAULT_NAVIGATION_DATA);

  const setNavigationData = (navigationData: { articleId: articleId; history: HistoryItem[] }): void => {
    setNavigationDataState(navigationData);
  };

  return {
    navigationData: navigationDataState,
    setNavigationData,
    resetHelp: () => {
      setNavigationData(DEFAULT_NAVIGATION_DATA);
    },
  };
};
